export const handleCancelToolAction = (state) => {
  const {
    selectedTool,
    isDragging,
    setIsDragging,
    isSelectedMovingActive,
    setIsSelectedMovingActive,
    isResizeActive,
    setIsResizeActive,
    setIsErasingActive,
    erasedPathKeys,
    paths,
    setPaths,
    currentPath,
    currentPathId,
    previousErasePoint,
    pointerDownTimeRef,
    // 동시편집
    yPathsRef,
  } = state

  if (selectedTool === 'select') {
    if (isDragging) setIsDragging(false)
    if (isSelectedMovingActive) setIsSelectedMovingActive(false)
    if (isResizeActive) {
      setIsResizeActive(false)
    }
  }

  if (
    selectedTool === 'pen-pressure' ||
    selectedTool === 'pen' ||
    selectedTool === 'pen-highlight' ||
    selectedTool === 'shape'
  ) {
    // delete lastPath information
    delete paths[currentPathId.current]
    setPaths({ ...paths })

    // [동시편집 - 삭제]
    yPathsRef.current.delete(currentPathId.current)

    currentPath.current = null
    currentPathId.current = 0
  }

  if (selectedTool === 'eraser') {
    // eraser follower 숨기기
    const eraserElement = document.getElementById('eraser')
    eraserElement.style.display = 'none'

    setIsErasingActive(false)
    previousErasePoint.current = { x: 0, y: 0 }

    // 지우기 선택된 path 삭제
    if (erasedPathKeys.current.length) {
      for (let erasedPathKey of erasedPathKeys.current) {
        const sgShapeDivElement = document.getElementById(`sg-shape-${erasedPathKey}`)
        sgShapeDivElement.style.opacity *= 4
      }
      erasedPathKeys.current = []
    }
  }
  pointerDownTimeRef.current = 0

  return true
}
